import React from "react";
import EventModalHeader from "./EventModalHeader";
import EventForm from "./EventForm";

const EventModal = ({
  show,
  selectedEvent,
  formData,
  setFormData,
  isOriginator,
  eventTypes,
  employeeList,
  suggestionFilter,
  setSuggestionFilter,
  setShowSuggestions,
  addEmployeeFromSuggestion,
  getCurrentUserRSVPStatus,
  errorMsg,
  t,
  language,
  theme,
  styles,
  screenSize,
  getShortName,
  onSubmit,
  onClose,
  onDelete,
  onStatusUpdate,
  handleButtonHover,
  handleInputChange,
}) => {
  if (!show) return null;

  const isEditing = !!selectedEvent;
  const eventType = formData.type;

  return (
    <div style={styles.modalOverlay} onClick={onClose}>
      <div
        style={styles.modalContainer}
        onClick={(e) => e.stopPropagation()}
      >
        <EventModalHeader
          isEditing={isEditing}
          isOriginator={isOriginator}
          formData={formData}
          eventTypes={eventTypes}
          eventType={eventType}
          t={t}
          language={language}
          styles={styles}
          screenSize={screenSize}
          getShortName={getShortName}
          onClose={onClose}
          handleButtonHover={handleButtonHover}
        />

        <EventForm
          formData={formData}
          setFormData={setFormData}
          selectedEvent={selectedEvent}
          isOriginator={isOriginator}
          isEditing={isEditing}
          eventTypes={eventTypes}
          employeeList={employeeList}
          suggestionFilter={suggestionFilter}
          setSuggestionFilter={setSuggestionFilter}
          setShowSuggestions={setShowSuggestions}
          addEmployeeFromSuggestion={addEmployeeFromSuggestion}
          getCurrentUserRSVPStatus={getCurrentUserRSVPStatus}
          errorMsg={errorMsg}
          t={t}
          language={language}
          theme={theme}
          styles={styles}
          screenSize={screenSize}
          getShortName={getShortName}
          onSubmit={onSubmit}
          onClose={onClose}
          onDelete={onDelete}
          onStatusUpdate={onStatusUpdate}
          handleButtonHover={handleButtonHover}
          handleInputChange={handleInputChange}
        />
      </div>
    </div>
  );
};

export default EventModal;
